import React from 'react';
import PropTypes from 'prop-types';

const TauriImage = ({ localImage, externalImage, alt, className, onClick }) => {
    const baseUrl = process.env.PUBLIC_URL || '';

    return (
        <img
            src={localImage ? `${baseUrl}${localImage}` : externalImage}
            alt={alt}
            className={className}
            onClick={onClick}
        />
    );
};

TauriImage.propTypes = {
    localImage: PropTypes.string,
    externalImage: PropTypes.string,
    alt: PropTypes.string.isRequired,
    className: PropTypes.string,
    onClick: PropTypes.func,
};

TauriImage.defaultProps = {
    localImage: null,
    externalImage: null,
    className: '',
    onClick: null,
};

export default TauriImage;
